import React from "react";

const CartSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 lg:grid-cols-3 gap-10 animate-pulse">

      {/* LEFT SIDE */}
      <div className="lg:col-span-2">

        {/* Title */}
        <div className="h-10 w-60 bg-gray-300 rounded mb-6"></div>

        <div className="border rounded-xl overflow-hidden">

          {/* Header */}
          <div className="grid grid-cols-12 px-6 py-4 border-b">
            <div className="col-span-7 h-4 bg-gray-300 rounded w-1/3"></div>
            <div className="col-span-3 h-4 bg-gray-300 rounded w-2/3 mx-auto"></div>
            <div className="col-span-2 h-4 bg-gray-300 rounded w-2/3 ml-auto"></div>
          </div>

          {/* Items */}
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="grid grid-cols-12 gap-4 px-6 py-6 border-b"
            >
              {/* Product */}
              <div className="col-span-7 flex gap-4">
                <div className="w-24 h-24 bg-gray-300 rounded-md"></div>

                <div className="flex-1 space-y-2">
                  <div className="h-5 bg-gray-300 rounded w-2/3"></div>
                  <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                  <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                </div>
              </div>

              {/* Qty */}
              <div className="col-span-3 flex justify-center items-center">
                <div className="h-10 w-20 bg-gray-300 rounded"></div>
              </div>

              {/* Price */}
              <div className="col-span-2 flex justify-end items-center">
                <div className="h-5 w-16 bg-gray-300 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="lg:col-span-1">
        <div className="border p-5 rounded-xl space-y-4">

          <div className="h-4 bg-gray-300 rounded w-1/3"></div>
          <div className="h-8 bg-gray-300 rounded w-1/2"></div>

          <div className="h-3 bg-gray-300 rounded w-full"></div>

          <div className="h-12 bg-gray-300 rounded w-full mt-4"></div>

        </div>
      </div>

    </div>
  );
};

export default CartSkeleton;